require("./wxapp-hover.scss");
var tpl = require("./wxapp-hover.html");

module.exports = function ($mod, $wxapp, pos, path) {
  if (!$mod) {
    return;
  }

  path = path || "pages/router/main?cityId=1";

  if (window.FCLoginWxappHover_img) {
    init($mod, $wxapp, window.FCLoginWxappHover_img);
  } else {
    $.ajax({
      url: "//wx-open-api.focus.cn/api/wxa/getLimitWXACode?appId=wxf7e3def609be52f7&sceneType=2&page=" +
        encodeURIComponent(path),

      success: function (e) {
        var img = "";
        if (e.code == 200 && e.data && typeof (e.data.imagePath) == 'string') {
          img = "https://t.focus-img.cn" + e.data.imagePath;
        }
        init($mod, $wxapp, img);
      },
      error: function () {
        init($mod, $wxapp, pos, "https://t.focus-img.cn/wx/acode/cbc4-bc7e-7765-983a-3a80-b72e-c541-73ef.jpg");
      }
    });
  }

};

function init($mod, $wxapp, img) {
  // $mod.append(
  //   velocityjs.render(tpl, {
  //     pfdACode: img
  //   })
  // );

  // const $wxappHover = $mod.find(".right-toolbar__wxapp-hover");

  // $wxappHover.hover(
  //   function () {
  //     $wxappHover.show();
  //   },
  //   function () {
  //     $wxappHover.hide();
  //   }
  // );
  // $wxapp.hover(
  //   function () {
  //     $wxappHover.show();
  //   },
  //   function () {
  //     $wxappHover.hide();
  //   }
  // );
}



// WEBPACK FOOTER //
// ./~/@front-end/common-module-vm/right-toolbar/wxapp-hover/wxapp-hover.js